import tracker from '@cell/cell-core/tracker';
import { getAnalyticsEventsFromNode, populateAnalyticsAttributeParams } from './utils';

export class AnalyticsClient {
  constructor() {
    const trackableNodes = this.findTrackableNodes(document.body);
    this.track(trackableNodes);

    this.observe();
  }

  observe() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          const trackableNodes = [];

          const analyticsEvents = getAnalyticsEventsFromNode(node);

          if (analyticsEvents.length > 0) {
            trackableNodes.push({ node, analyticsEvents });
          }

          trackableNodes.push(...this.findTrackableNodes(node));

          this.track(trackableNodes);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  findTrackableNodes(node) {
    if (!node.children || node.children.length === 0) return [];

    const trackableNodes = [];

    for (let i = 0; i < node.children.length; i++) {
      const childNode = node.children[i];
      const analyticsEvents = getAnalyticsEventsFromNode(childNode);

      if (analyticsEvents.length > 0) {
        trackableNodes.push({ node: childNode, analyticsEvents });
      }

      trackableNodes.push(...this.findTrackableNodes(childNode));
    }

    return trackableNodes;
  }

  track(nodes) {
    nodes.forEach(({ node, analyticsEvents }) => {
      analyticsEvents.forEach((event) => {
        this.listen(node, event);
      });
    });
  }

  listen(node, event) {
    const { name, params } = event;

    switch (event.type) {
      case 'visible': {
        this.observeVisibility(node, (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const populatedParams = populateAnalyticsAttributeParams(node, params);

              tracker.allV2(name, populatedParams);
            }
          });
        });

        break;
      }

      case 'invisible': {
        this.observeVisibility(node, (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              const populatedParams = populateAnalyticsAttributeParams(node, params);

              tracker.allV2(name, populatedParams);
            }
          });
        });

        break;
      }

      case 'mouseenter': {
        node.addEventListener('mouseenter', () => {
          const populatedParams = populateAnalyticsAttributeParams(node, params);

          tracker.allV2(name, populatedParams);
        });

        break;
      }

      case 'click': {
        node.addEventListener('click', () => {
          const populatedParams = populateAnalyticsAttributeParams(node, params);

          tracker.allV2(name, populatedParams);
        });

        break;
      }

      case 'change': {
        node.addEventListener('change', () => {
          const populatedParams = populateAnalyticsAttributeParams(node, params);

          tracker.allV2(name, populatedParams);
        });

        break;
      }

      default: {
        throw new Error(`Unknown event type: ${eventAttributes.type}`);
      }
    }
  }

  observeVisibility(node, cb) {
    const options = {
      // Use the viewport as the root..
      root: null,
      // No margin added to the root bounding box.
      rootMargin: '0px',
      // When 50% of the element is visible.
      threshold: 0.5,
    };

    // Create a new intersection observer.
    const visibilityObserver = new IntersectionObserver(cb, options);

    // Start observing.
    visibilityObserver.observe(node);

    return visibilityObserver;
  }
}
